var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sayfayok"},[_c('h1',{staticClass:"h1"},[_vm._v("Yetkisiz İşlem")]),_vm._v(" "),_c('router-link',{staticClass:"url",attrs:{"to":"/panel"}},[_vm._v(_vm._s(_vm.$t('Hata.10')))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cbcd8d1","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/spesiyal/Yetkisiz.vue
// module id = 677
// module chunks = 0